export enum SwitchBillTo {
  Landlord = 0,
  LandlordCOAgency = 1,
  Agency = 2,
}
